// Utility functions for fetching URL slugs from Contentful
import { getAPI } from '../api/client';

/**
 * Fetches all URL slugs for a given content type from Contentful
 * @param contentType - The Contentful content type to fetch
 * @param pathPrefix - Optional prefix to prepend to each slug (e.g., '/blog')
 * @returns Array of URL paths
 */
export async function fetchContentSlugs(
  contentType: string,
  pathPrefix = '',
): Promise<string[]> {
  try {
    const client = getAPI();
    const resp = await client.getEntries({
      content_type: contentType,
      limit: 1000,
      select: ['fields.urlSlug'],
    });

    return resp.items
      .map((p: any) => {
        const slug = p.fields.urlSlug;
        if (!slug) return null;
        return pathPrefix ? `${pathPrefix}/${slug}` : `/${slug}`;
      })
      .filter(Boolean) as string[];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      `Error fetching ${contentType} slugs from Contentful:`,
      error,
    );
    return [];
  }
}

/**
 * Fetches all landing page slugs from Contentful
 * Returns just the slug strings without the leading slash
 * (for backward compatibility with getStaticPaths)
 */
export async function fetchLandingPageSlugs(): Promise<string[]> {
  try {
    const client = getAPI();
    const resp = await client.getEntries({
      content_type: 'landingPage',
      limit: 1000,
      select: ['fields.urlSlug'],
    });

    return resp.items
      .map((p: any) => p.fields.urlSlug)
      .filter(Boolean) as string[];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching landing page slugs from Contentful:', error);
    return [];
  }
}
